import Footer from './Footer.css';
function getFooter() {
  return <div className='footer_wrap'>
    <ul>
      <li>Link 1</li>
      <li>Link 2</li>
      <li>Link 3</li>
    </ul>
  </div>
}

export default getFooter;